import { BiomassBurningCellDisplay } from '../CellDisplays/BiomassBurningCellDisplay'
import { TraitCellDisplayProps } from '../types'

export const BiomassBurningCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const detail = params.row.findDetail({ traitId, year })
  return <BiomassBurningCellDisplay value={detail} />
}
